/* eslint-disable */
import React from "react";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { motion } from "framer-motion";

import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";
import { fetchGraphQL, fetchUserGet } from "../../../services/api-raindrop";

import RaindropModalComponent from "../../../ui-components/raindrop-modal-component/raindrop-modal-component.tsx";
import RaindropTitle from "../../../ui-components/raindrop-title/raindrop-title.tsx";

const SplashScreenLoadingComponent = () => {
  return (
    <div className="flex flex-col h-full w-full items-center justify-center px-10">
      <motion.div
        initial={{
          opacity: 0,
          scale: 0,
          y: 50,
        }}
        animate={{
          opacity: [0, 1],
          scale: [0, 1],
          radius: [0, 100],
          x: [-100, 100],
        }}
        transition={{
          repeat: Infinity,
          repeatType: "mirror",
          duration: 1,
          scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
        }}
        className="w-4 h-4 bg-color-raindrop-primary rounded-full absolute "
      />

      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 1,
          scale: {
            type: "spring",
            visualDuration: 0.4,
            bounce: 0.5,
          },
        }}
      >
        <RaindropTitle isVersion2={true} />
      </motion.div>
    </div>
  );
};

const RaindropBaseAuthenticated = ({
  userCurrent,
  setUserCurrent,
  currentModalComponent = null,
  setCurrentModalComponent = () => {},
}) => {
  const navigate = useNavigate();

  const [appIsLoading, setAppIsLoading] = React.useState(true);

  let blur = "blur-none";

  useEffect(() => {
    // If user is already authenticated, do nothing
    if (userCurrent) {
      setAppIsLoading(false);

      // if (userCurrent.status === "USER_STATUS_ONBOARDING") {
      //   navigate("/raindrop/tour");
      // }
      return;
    }

    // TODO: sausageObjects
    fetchGraphQL(`
      query {
       accountUser {
        id
        status
        namePreferred
        email
        account {
          id
          presignedUrl
          paymentMethodActive
          isRaindropPlus
          accountAwardFeatured {
            id
            isFeatured
            award {
              slug
            }
          }
          streak {
            lastQuizDate
            longestStreak
            currentStreak
            hasCompletedQuizToday
          }
          primaryWaterfall {
            id
          }
          username
          accountPlan {
            id
            subunits
            isPaused
            subunitsCurrency
            contributionDay
            isSupportingRaindrop
            sausages {
              id
              percentage
              styleColor
              organisation {
                id
                name
                presignedUrlLogo
                isHydrated
              }
              waterfall {
                id
                title
                organisation {
                  id
                  presignedUrlLogo
                }
                account {
                  id
                  presignedUrl
                }
              }
            }
          }
        }
       }
      }
    `)
      .then((result) => {
        if (result.errors) {
          console.error("RD-4562", result);
        }
        if (result.data.accountUser == null) {
          return;
        }

        setUserCurrent(result.data.accountUser);
      })
      .catch((error) => {
        console.error("RD-4563", error);
      })
      .finally(() => {
        setAppIsLoading(false);
      });
  }, [navigate]);

  if (currentModalComponent) {
    blur = "blur-md";
  }

  if (appIsLoading) {
    return (
      <div className="flex flex-col h-full w-full relative ">
        <SplashScreenLoadingComponent />
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full w-full relative ">
      {/* TODO This should be it's own layer --START */}
      {currentModalComponent && (
        <RaindropModalComponent
          setCurrentModalComponent={setCurrentModalComponent}
        >
          {currentModalComponent}
        </RaindropModalComponent>
      )}
      {/* TODO This should be it's own layer -- END */}
      <div className={`flex flex-col w-full h-full transition-all ${blur}`}>
        <Outlet />
      </div>
    </div>
  );
};

export default RaindropBaseAuthenticated;
